import { render, staticRenderFns } from "./coupon-list.vue?vue&type=template&id=1a719f1d&scoped=true&"
import script from "./coupon-list.vue?vue&type=script&lang=js&"
export * from "./coupon-list.vue?vue&type=script&lang=js&"
import style0 from "./coupon-list.scss?vue&type=style&index=0&id=1a719f1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a719f1d",
  null
  
)

export default component.exports